// @flow

import * as React from 'react';
import {Shell} from 'docs/shell/Shell';
import {Content} from 'docs/shell/content/Content';
import {Sidebar} from 'docs/shell/sidebar/Sidebar';
import {VideoPlayer} from 'docs/shell/videos/VideoPlayer';

// TODO (nkohari): Consider replacing this with something like react-router?
export const Router = () => (
  <>
    <Shell sidebar={<Sidebar />}>
      <Content />
    </Shell>
    <VideoPlayer />
  </>
);
